import CanvasPlugin, { Canvas } from '../core/CanvasPlugin';
import { Video } from '../core/VideoPlugin';
import Paella from '../Paella';

export class AudioCanvas extends Canvas {
    constructor(player: Paella, videoContainer: HTMLElement) {
        super('div', player, videoContainer);
        this.element.classList.add("image-canvas");
    }

    async loadCanvas(player: Video) {
        player.element.style.width = "100%";
        player.element.style.height= "100%";
    }
}

export default class AudioCanvasPlugin extends CanvasPlugin {
    get name() {
		return "es.upv.paella.audioCanvas";
	}

    get canvasType() { return 'audio'; }

    getCanvasInstance(videoContainer: HTMLElement) {
        return new AudioCanvas(this.player, videoContainer);
    }

    isCompatible(stream: any) : boolean {
        return true;
    }
}
